import { Skeleton } from "../../../../components/atoms/Skeleton";

export function SkeletonBarChart({ rows = 4}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: "13px",
        paddingInline: "28px 11.5px"
      }}>
      {Array.from({ length: rows }).map((_, i) => {
        return (
          <div
            key={i}
            style={{
              display: "flex",
              width: "100%",
              gap: "10px",
              flexDirection: "row",
              alignItems: "center"
            }}>
            <Skeleton style={{ width: "100px", height: "10px" }} />
            <Skeleton style={{ width: "100%", height: "45px" }} />
          </div>
        );
      })}
    </div>
  );
}
